<script>
  import { createEventDispatcher } from 'svelte';
  import { AlertTriangle, X } from 'lucide-svelte';
  import { _ } from '../lib/i18n.js';

  export let title = '';
  export let message = '';
  export let confirmText = '';
  export let cancelText = '';
  export let confirmClass = 'btn-primary';
  export let loading = false;

  $: displayTitle = title || $_('confirmModal.defaultTitle');
  $: displayMessage = message || $_('confirmModal.defaultMessage');
  $: displayConfirmText = confirmText || $_('confirmModal.defaultConfirm');
  $: displayCancelText = cancelText || $_('confirmModal.defaultCancel');

  const dispatch = createEventDispatcher();

  function handleConfirm() {
    dispatch('confirm');
  }

  function handleCancel() {
    dispatch('cancel');
  }

  function handleKeydown(event) {
    if (event.key === 'Escape' && !loading) {
      handleCancel();
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<!-- Modal backdrop -->
<div class="modal-backdrop fade-in">
  <!-- Modal -->
  <div class="modal-content max-w-md w-full scale-in">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-gray-200/60 flex items-center justify-between bg-linear-to-r from-red-50/50 to-transparent">
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 bg-linear-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center">
          <AlertTriangle class="h-5 w-5 text-white" />
        </div>
        <div>
          <h2 class="text-lg font-bold text-gray-900">{displayTitle}</h2>
          <p class="text-sm text-gray-500">{$_('confirmModal.cannotUndo')}</p>
        </div>
      </div>
      {#if !loading}
        <button
          on:click={handleCancel}
          class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-xl transition-all duration-200"
        >
          <X size={20} />
        </button>
      {/if}
    </div>

    <!-- Content -->
    <div class="px-6 py-4">
      <p class="text-sm text-gray-700">{displayMessage}</p>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
      <button
        type="button"
        on:click={handleCancel}
        class="btn btn-secondary"
        disabled={loading}
      >
        {displayCancelText}
      </button>
      <button
        type="button"
        on:click={handleConfirm}
        class="btn {confirmClass}"
        disabled={loading}
      >
        {#if loading}
          <svg class="animate-spin -ml-1 mr-3 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        {/if}
        {displayConfirmText}
      </button>
    </div>
  </div>
</div>